export var TabsVariants;
(function (TabsVariants) {
    TabsVariants["FullWidth"] = "fullWidth";
    TabsVariants["Scrollable"] = "scrollable";
})(TabsVariants || (TabsVariants = {}));
export var TabsThemes;
(function (TabsThemes) {
    TabsThemes["Light"] = "light";
    TabsThemes["Dark"] = "dark";
})(TabsThemes || (TabsThemes = {}));
export var TabsScrollButtonsProps;
(function (TabsScrollButtonsProps) {
    TabsScrollButtonsProps["Auto"] = "auto";
})(TabsScrollButtonsProps || (TabsScrollButtonsProps = {}));
